import 'bootstrap/js/src/collapse';
import 'protons';
import './_accordion.scss';
import './_accordion.twig';

export const name = 'accordion';

export const defaults = {};

export function disable() {}

export function enable() {}

export default enable;
